<template>
  <div class="gears">
    <img class="gear-1" src="../../assets/Sections/brown-gear.png"/>
    <img class="gear-2" src="../../assets/Sections/brown-gear2.png"/>
  </div>
</template>

<script>
    export default {
        name: "Gear"
    }
</script>

<style scoped>

  .gears {
    position: relative;
    width: 100%;
    opacity: 0.7;
    z-index: 0;
  }

  .gear-1 {
    position: absolute;
    width: 20%;
    left: 20%;
    margin-top: 19%;
    animation: spin 5s linear infinite;
  }

  .gear-2 {
    position: absolute;
    width: 60%;
    animation: spin2 8s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes spin2 {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(-360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Parts/Gear.vue